import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=f7fa20c4&scoped=true"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"
import style0 from "./bill.vue?vue&type=style&index=0&id=f7fa20c4&prod&scoped=true&lang=css"
import style1 from "./bill.vue?vue&type=style&index=1&id=f7fa20c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fa20c4",
  null
  
)

export default component.exports